import { createSlice } from "@reduxjs/toolkit";

const menuSlice = createSlice({
    name: "menu",
    initialState: {
        menu: [],
        category: [],
        loading: false,
        error: null,
    },
    reducers: {
        menuRequest(state) {
            state.loading = true;
            state.error = null;
        },
        menuSuccess(state, action) {
             state.loading = false;
            state.menu = action.payload.menu;
            state.category = action.payload.category;
        },
        menuFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearError(state) {
            state.error = null;
        },
    },
});

const { actions, reducer } = menuSlice;

export const {
    menuRequest,
    menuSuccess,
    menuFail,
    clearError,
} = actions;

export default reducer;
